import { Injectable } from '@angular/core';
import {Observable, tap} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";

const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Injectable({
  providedIn: 'root'
})
export class BillingService {
  constructor(private http: HttpClient) {}

  /**
   * consulta para obtener las tarifas por rutas
   */
  getBilling(data: any): Observable<any>{
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/billing/getbilling`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * consulta para obtener los permisos
   */
  add(data: any): Observable<any>{
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/billing/create`,
        data,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * consulta para eliminar un registro
   */
  delete(data: any): Observable<any>{
    const body = JSON.stringify(data);
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/billing/delete`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * consulta para obtener las categorías
   */
  getCategories(): Observable<any>{
    const body = JSON.stringify({});
    const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/routes/getcategories`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * Función para mostrar o remover loading
   */
  controlLoader(show:boolean):void{
    // let elemet: any = document.getElementsByClassName("loader-screen")[0];
    // elemet.style.opacity = 0.8;
    // elemet.style.display = elemet.style.display === 'none' ? '' : 'none';
  }


}
